export function isIOS() {
  if (typeof navigator === "undefined") return false;

  return (
    /iPad|iPhone|iPod|Macintosh/.test(navigator.userAgent) &&
    !(window as any).MSStream
  );
}

/**
 * Strict iOS/iPadOS *device* check — iPhone/iPad only, **excludes desktop Mac**.
 * (`isIOS()` above is intentionally broad: it treats any Apple/Mac UA as iOS for
 * app-store routing.) Use this to gate native-HLS playback in `useShaka` —
 * desktop Mac must stay on MSE so HLS subtitle tracks are exposed.
 */
export function isIOSDevice() {
  if (typeof navigator === "undefined") return false;

  const ua = navigator.userAgent;
  return (
    /iPhone|iPad|iPod/.test(ua) ||
    // iPadOS 13+ reports as "Macintosh"; disambiguate via touch points.
    (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1)
  );
}
